import { RID } from '@sharefiledev/sfplugin-resource-id';
import { DocumentTemplateTypes } from '../constants';
import { DocumentTemplateType } from '../data/interfaces/DocumentTemplate';

export const getFileExtension = (fileName: string) => {
	if (fileName) {
		// "Document.pdf" => ".pdf"
		return `.${fileName.toLowerCase().split('.').pop()}`;
	}
};

const getFileNameWithoutExtension = (fileName: string) => {
	// "Document.pdf" => "Document"
	return fileName.split('.').slice(0, -1).join('.') || fileName;
};

export const replaceSpecialCharsWithSpace = (fileName: string) => {
	// "Document_new.pdf" => "Document new"
	return getFileNameWithoutExtension(fileName)
		.replace(/[_`~!@#$%^&*(){};:'",.?[\]|\s\\|/<>=]+/g, ' ')
		.trim();
};

export const isDocxFile = (fileName: string) => {
	return getFileExtension(fileName?.toLowerCase()) === '.docx';
};

export const isSupportedFileFormat = (
	fileExtension: string | null,
	templateType?: DocumentTemplateType
): boolean => {
	if (!fileExtension) {
		return false;
	}
	const { Dynamic, Static } = DocumentTemplateTypes;

	const supportedFormats =
		templateType === Dynamic.type
			? Dynamic.supportedFileExtensions
			: Static.supportedFileExtensions;

	return supportedFormats.includes(fileExtension);
};

export function getFileRIDWithoutVersion(rid: string): string {
	const parsedRID = RID.parse(rid);
	if (parsedRID.entityType !== 'filever') {
		// If the RID does not contain file version, return the parent RID directly
		return parsedRID.toString();
	}
	// '*/file-u4s3vq3XeeLI/filever-59kHLuVnyDxk' => '*/file-u4s3vq3XeeLI'
	return parsedRID.parent().toString();
}

export function getMicrosoftOfficeAppName(fileName: string) {
	const extension = getFileExtension(fileName);
	switch (extension) {
		case 'ods':
		case 'xlsb':
		case 'xlsm':
		case 'xlsx':
			return 'Excel';
		case 'odp':
		case 'ppsx':
		case 'pptx':
			return 'PowerPoint';
		case 'docm':
		case 'docx':
		case 'odt':
		default:
			return 'Word';
	}
}
